// Espelho de UX da politica obrigatoria do backend. O servidor continua sendo
// a autoridade; isto apenas impede que usuario comum veja/ative o olhinho.
export const canUseBroadTicketView = (user) => user?.profile === "admin";
